import request from '@/api/request'
import requestv2 from '@/api/requestv2'

const getCommissions = function () {
  return request({
    url: '/commissions',
    method: 'get'
  })
}

const getCardCommission = function (card) {
  return request({
    url: `/commissions/${card}`,
    method: 'get'
  })
}

const v2 = {
  getCommissions: function () {
    return requestv2({
      url: '/guest/commissions',
      method: 'get'
    })
  },
  getCardCommission: function (card) {
    return requestv2({
      url: `/guest/commissions/${card}`,
      method: 'get'
    })
  }
}
export default {
  getCommissions,
  getCardCommission,
  v2
}
